export default __webpack_public_path__ + "static/media/eye_open.1b093f53.svg";